import { APIRoute } from '@/modules/utils'
import { IRI } from 'emt-library'

export const Route = (favoriteIRI: IRI): APIRoute => ({
  method: 'DELETE',
  path: favoriteIRI,
})

export type Response = never
